module.exports = "\r\n{{#each book in view.books}}\r\n  {{view view.bookView controller=controller model=book}}\r\n{{/each}}\r\n\r\n\r\n\r\n\r\n\r\n\r\n"